import cx from 'classnames';
import { UserAvatar } from 'Components/shared/UserAvatar';
import { observer } from 'mobx-react';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Dropdown, DropdownItemProps } from 'semantic-ui-react';
import { AtMentionMemberItemProps } from './interfaces';

/**
 * List item display of a `Participant` in a `Channel`, who can be Mentioned.
 *
 * **This named class is not decorated with `@observer`.** Use the default export from this module if you need the decorated class.
 *
 * @export
 * @class ChannelMembers
 */
export class AtMentionMemberItem extends React.Component<AtMentionMemberItemProps> {
  /** A map of Presence status keys, with display names as values */
  statusDisplayNames = {
    Active: 'Available',
    Idle: 'Idle',
    Away: 'Away',
    OnCall: 'On Call',
    OffLine: 'Offline',
  };

  onClick = (e: React.MouseEvent) => {
    const { onMentionClick, participantPerson } = this.props;
    e.preventDefault();
    e.stopPropagation();
    onMentionClick(participantPerson.person.sourceId.toString());
    return false;
  };

  componentDidUpdate(prevProps: AtMentionMemberItemProps) {
    if (
      this.props.isSelected &&
      this.props.isSelected !== prevProps.isSelected
    ) {
      const itemDomNode = ReactDOM.findDOMNode(this.itemRef) as HTMLDivElement;
      itemDomNode.scrollIntoView({ behavior: 'auto', block: 'center' });
    }
  }

  itemRef: React.Component<DropdownItemProps>;
  private registerRef = (di: React.Component<DropdownItemProps>) =>
    (this.itemRef = di);

  render() {
    const { isSelected, participantPerson, selectPersonPresenceStatus } =
      this.props;
    const presenceStatus = selectPersonPresenceStatus(
      participantPerson.person.sourceId
    );
    const prsIdStr = participantPerson.person.sourceId;
    return (
      <Dropdown.Item
        className={cx('user-mention-row semantic-flex-row', {
          selected: isSelected,
        })}
        onClick={this.onClick}
        id={`ammi-${prsIdStr}`}
        key={prsIdStr}
        ref={this.registerRef}
      >
        <div className="avatar user-mention-avatar">
          <UserAvatar
            name={participantPerson.person.name}
            presence={selectPersonPresenceStatus(prsIdStr)}
            image={participantPerson.person.avatarUrl}
            size={36}
          />
        </div>
        <div className="presence" data-value={prsIdStr}>
          <div className="mention-text-wrapper" data-value={prsIdStr}>
            <div className="name" data-value={prsIdStr}>
              {participantPerson.person.name}
            </div>
            <span
              className={cx('text', presenceStatus.state)}
              data-value={prsIdStr}
            >
              {this.statusDisplayNames[presenceStatus.state]}
            </span>
          </div>
        </div>
      </Dropdown.Item>
    );
  }
}

export default observer(AtMentionMemberItem);
